import AutoplayModel from "slotworks/model/autoplay/autoplay-model";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class IsAutoplay extends Decision {
    public evaluate() {
        return AutoplayModel.isAutoPlaying() ? Exit.True : Exit.False;
    }
}
